import React from 'react';
import { useTranslation } from 'react-i18next';
import Card from '../card/Card';

const ServicesSection = ({ skills }) => {
  const { t } = useTranslation('home');

  return (
    <section className="services section">
      <div className="container">
        <h2 className="title-2">
          {t('services.title')} <span className="accent">{t('services.titleAccent')}</span>
        </h2>
        <div className="services__cards">
          <div className="services__cards-inner">
            {skills.map((skill, idx) => (
              <Card
                key={idx}
                card_title={skill.title_skill}
                descriptions={skill.descriptions}
                cta={skill.cta}
                link={skill.link}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
